// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rqwV","badges":"styles_badges__KZTuY"};